<template>
  <inertia-link
    :href="$route('home.blogs.show', { slug: data.slug })"
    class="item"
  >
    <div class="thumbnail">
      <img v-lazy="data.thumbnail" :alt="data.title" />
    </div>
    <div class="content">
      <div class="title">
        <h3 class="wrap-text-2">{{ data.title }}</h3>
        <div class="date">{{ data.disp_date }}</div>
      </div>
    </div>
  </inertia-link>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  height: 300px;
  overflow: hidden;
  border-radius: var(--border-radius);
  background: var(--card-color);
  box-shadow: var(--box-shadow);
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  transition: var(--transition);

  &:before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      356deg,
      rgb(0 0 0 / 55%) 18%,
      rgb(0 0 0 / 0%) 86%
    );
    z-index: 2;
  }

  .thumbnail {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: all 0.25s ease;
    }
  }

  .content {
    padding: 1rem;
    position: relative;
    z-index: 5;
    width: 100%;
    color: #fff;
    .title {
      h3 {
        font-size: 1.2rem;
        line-height: 1.1;
        font-weight: bold;
        font-family: var(--font-family);
        margin-bottom: 0;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
      }
      .date {
        font-size: 0.86rem;
        margin-top: 0.4rem;
        opacity: 0.8;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
      }
    }
  }

  &:hover {
    transform: scale(1.02);

    .thumbnail {
      img {
        transform: scale(1.04);
      }
    }
  }
}
</style>